import { render, staticRenderFns } from "./BaseLabel.vue?vue&type=template&id=4000f3ec"
import script from "./BaseLabel.vue?vue&type=script&lang=js"
export * from "./BaseLabel.vue?vue&type=script&lang=js"
import style0 from "./BaseLabel.vue?vue&type=style&index=0&id=4000f3ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports